<template>
	<div class="positioning-brand-renderer" :class="{ 'positioning-brand-renderer--subset': line?.kind === 'subset' }">
		<span class="positioning-brand-renderer__name">{{ line?.name }}</span>
		<span v-if="line?.caption" class="positioning-brand-renderer__caption">{{ line.caption }}</span>
		<template v-else>
			<v-chip v-for="tag in tags" :key="tag.text" size="small" variant="tonal" :color="tag.color" class="positioning-brand-renderer__tag" readonly>{{ tag.text }}</v-chip>
		</template>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	params: { type: Object, required: true },
});

const line = computed(() => props.params?.data || null);
const tags = computed(() => (Array.isArray(line.value?.tags) ? line.value.tags : []));
</script>

<style lang="scss">
@use '@/styles/variables' as *;

.positioning-brand-renderer {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	min-width: 0;

	&__name {
		font-weight: 700;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	&__caption {
		font-size: $font-size-small;
		color: rgba(var(--v-theme-on-surface), 0.55);
	}

	&__tag {
		flex: none;
		font-weight: 600;
	}

	&--subset {
		padding-left: 22px;

		.positioning-brand-renderer__name {
			font-weight: 400;
			color: rgba(var(--v-theme-on-surface), 0.7);
		}
	}
}
</style>
